import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/v2/button";
import { ROUTES } from "@/constants/routes";

export function LinkSentContent() {
  const { t } = useTranslation();

  return (
    <div className="space-y-4 pt-2">
      <Button asChild className="w-full">
        <Link to={ROUTES.login}>{t("common.signIn")}</Link>
      </Button>
    </div>
  );
}
